import { render, staticRenderFns } from "./AppealSearch.vue?vue&type=template&id=6c347ddd"
import script from "./AppealSearch.vue?vue&type=script&lang=js"
export * from "./AppealSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports